import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnonymousGuard } from 'projects/shared/lib/guards/anonymous.guard';
import { AuthenticatedGuard } from 'projects/shared/lib/guards/authenticated.guard';
import { LoginComponent } from './components/standalone/login/login.component';
import { ContactRequestComponent } from 'projects/shared/lib/components/standalone/contact-request/contact-request.component';
import { ContentPageComponent } from './components/standalone/content-page/content-page.component';
import { ContentPageModule } from './components/standalone/content-page/content-page.module';
import { CartPreviewInterceptorGuard } from './guards/cart-preview-interceptor.guard';
import { RedirectGuard } from 'projects/shared/lib/redirect.guard';
import { AgeVerificationInterceptorGuard } from './guards/age-verification-interceptor.guard';
import { ShopStateGuard } from '../../../shared/lib/guards/shop-state.guard';
import { ErrorBaseComponent } from 'projects/shared/lib/components/standalone/error/error-base.component';
import { ErrorBaseModule } from 'projects/shared/lib/components/standalone/error/error-base.module';
import { OfflineBaseModule } from 'projects/shared/lib/components/standalone/offline/offline-base.module';
import { OfflineBaseComponent } from 'projects/shared/lib/components/standalone/offline/offline-base.component';
import { MaintenanceBaseComponent } from 'projects/shared/lib/components/standalone/maintenance/maintenance-base.component';
import { MaintenanceBaseModule } from 'projects/shared/lib/components/standalone/maintenance/maintenance-base.module';
import { LoginAsBaseModule } from 'projects/shared/lib/components/standalone/login-as/login-as-base.module';
import { LoginAsBaseComponent } from 'projects/shared/lib/components/standalone/login-as/login-as-base.component';

// const BASE_PATH: string = ".";
const ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,

    canLoad: [AnonymousGuard],
    canActivate: [
      ShopStateGuard,
      AnonymousGuard,
      CartPreviewInterceptorGuard
    ],
  },
  {
    path: 'register',
    loadChildren: () => import('./modules/register/register-routing.module').then(m => m.RegisterRoutingModule),

    canLoad: [AnonymousGuard],
    canActivate: [
      ShopStateGuard,
      AnonymousGuard,
      CartPreviewInterceptorGuard
    ],
  },
  {
    path: 'category',
    loadChildren: () => import('./modules/category/category-routing.module').then(m => m.CategoryRoutingModule),

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard
    ],
    canActivateChild: [CartPreviewInterceptorGuard]
  },
  {
    path: 'contact-request',
    component: ContactRequestComponent,

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard
    ]
  },
  {
    path: 'content',
    component: ContentPageComponent,

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard
    ]
  },
  {
    path: 'password-reset',
    loadChildren: () => import('./modules/password-reset/password-reset-routing.module').then(m => m.PasswordResetRoutingModule),

    canLoad: [AnonymousGuard],
    canActivate: [
      ShopStateGuard,
      AnonymousGuard,
      CartPreviewInterceptorGuard
    ],
  },
  {
    path: 'login-as',
    component: LoginAsBaseComponent,

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard
    ],
  },
  {
    path: 'product',
    loadChildren: () => import('./modules/product/product-routing.module').then(m => m.ProductRoutingModule),

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard
    ]
  },
  {
    path: 'user',
    loadChildren: () => import('./modules/user/user-routing.module').then(m => m.UserRoutingModule),

    canLoad: [AuthenticatedGuard],
    canActivate: [
      ShopStateGuard,
      AuthenticatedGuard,
      CartPreviewInterceptorGuard,
      AgeVerificationInterceptorGuard
    ],
  },
  {
    path: 'shopping-cart',
    loadChildren: () => import('./modules/cart/cart-routing.module').then(m => m.CartRoutingModule),

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard,
      AgeVerificationInterceptorGuard
    ]
  },
  {
    path: 'checkout',
    loadChildren: () => import('./modules/ckeckout/ckeckout-routing.module').then(m => m.CkeckoutRoutingModule),

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard,
      AgeVerificationInterceptorGuard
    ]
  },
  {
    path: 'error',
    component: ErrorBaseComponent,

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard
    ]
  },
  {
    path: 'offline',
    component: OfflineBaseComponent,

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard
    ]
  },
  {
    path: 'maintenance',
    component: MaintenanceBaseComponent,

    canActivate: [
      ShopStateGuard,
      CartPreviewInterceptorGuard
    ]
  },
  {
    path: '',
    component: LoginComponent,
    canActivate: [
      ShopStateGuard,
      RedirectGuard
    ],
  },
  {
    path: '**',
    component: ErrorBaseComponent,
    canActivate: [
      ShopStateGuard
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(ROUTES, {
      enableTracing: false,
      scrollPositionRestoration: "disabled",
    }),
    // import of these modules is required since the Components inside are referenced
    LoginComponent,
    ContactRequestComponent,
    ContentPageModule,
    ErrorBaseModule,
    LoginAsBaseModule,
    MaintenanceBaseModule,
    OfflineBaseModule,
  ],
  exports: [
    RouterModule,
  ]
})
export class AppRoutingModule { }
